import { jsNode } from '@shared/node-v1.0.0'

import v010 from '@nodes/create-local-data-v0.1.0'

export default jsNode(
	'createLocalData',
	{
		'v0.1.0': v010,
	},
	{ docs: '' }
)
